import React from 'react';
import coinImg from '../../assets/images/b1.png';
import '../DashboardSkeleton.css';

const formatPrice = (value) => `₹${Number(value || 0)}`;

const AttemptsPacks = ({ pack, onBuy, isBuying }) => {
  const amount = Number(pack.attempt_amount || 0);
  const price = Number(pack.price || 0);
  const discountedPrice = Number(pack.discounted_price || 0);
  const hasDiscount = price > 0 && discountedPrice > 0 && discountedPrice < price;
  const discount = hasDiscount ? Math.round((1 - discountedPrice / price) * 100) : 0;

  return (
    <div className="coinn-pack-card" role="button" tabIndex={isBuying ? -1 : 0}
      onClick={() => { if (!isBuying) onBuy?.(pack); }}
      onKeyDown={(event) => { if (event.target === event.currentTarget && !isBuying && (event.key === 'Enter' || event.key === ' ')) { event.preventDefault(); onBuy?.(pack); } }}>
      <div className="coinn-pack-card-top">
        <div className="coinn-pack-icon-wrapper">
          <div className="coinn-pack-iconn">
            <img src={coinImg} alt="" />
          </div>
        </div>
        <div className="coinn-pack-info">
          <h3>{amount}</h3>
          <span>{pack.attempt_label || `${amount} Reattempts`}</span>
        </div>
      </div>

      <div className="coinn-pack-divider" />

      <div className="coinn-pack-price-row">
        <div className="coinn-pack-prices">
          <span className="coinn-pack-current-price">{formatPrice(discountedPrice)}</span>
          {hasDiscount ? <span className="coinn-pack-old-price">{formatPrice(price)}</span> : null}
        </div>
        {hasDiscount ? <span className="coinn-pack-discount">{discount}% OFF</span> : null}
      </div>

      <button type="button" className="coinn-pack-buy-btn" onClick={(event) => { event.stopPropagation(); onBuy?.(pack); }} disabled={isBuying}>
        {isBuying ? 'Loading...' : 'Buy Now'}
      </button>
    </div>
  );
};

const AttemptPackShimmer = () => (
  <div className="coinn-pack-card" aria-hidden="true" data-testid="attempt-pack-shimmer">
    <div className="coinn-pack-card-top">
      <span className="dashboard-skeleton dashboard-skeleton--button" style={{ width: 58, height: 58, borderRadius: '50%' }} />
      <div className="coinn-pack-info">
        <span className="dashboard-skeleton dashboard-skeleton--line" style={{ width: 70, height: 22 }} />
        <span className="dashboard-skeleton dashboard-skeleton--line" style={{ width: 92, marginTop: 10 }} />
      </div>
    </div>
    <div className="coinn-pack-divider" />
    <div className="coinn-pack-price-row">
      <div className="coinn-pack-prices">
        <span className="dashboard-skeleton dashboard-skeleton--line" style={{ width: 74, height: 20 }} />
        <span className="dashboard-skeleton dashboard-skeleton--line" style={{ width: 62, marginTop: 8 }} />
      </div>
      <span className="dashboard-skeleton dashboard-skeleton--line" style={{ width: 70, height: 18 }} />
    </div>
    <span className="dashboard-skeleton dashboard-skeleton--button" style={{ display: 'block', width: '100%', height: 46, marginTop: 18 }} />
  </div>
);

const AssessmentPackCard = ({ packs = [], isLoading = false, isError = false, error, onRetry, onBuy, buyingPackId = null, loadingCount = 4, packType = 'reattempt', heading = 'Buy Re-attempt Addons', description = 'Choose extra assessment attempts for uninterrupted practice' }) => (
  <div className="coinn-packs-container">
    <div className="coinn-packs-header">
      <div>
        <h2>{heading}</h2>
        <p>{description}</p>
      </div>
    </div>

    <div className="coinn-packs-grid" aria-busy={isLoading} aria-label={isLoading ? `Loading ${packType} packs` : undefined}>
      {isLoading && Array.from({ length: loadingCount }, (_, index) => <AttemptPackShimmer key={index} />)}
      {isError && <p role="alert">{error?.message || `Unable to load ${packType} packs.`} <button type="button" onClick={onRetry}>Retry</button></p>}
      {!isLoading && !isError && packs.length === 0 && <p>No {packType} packs available.</p>}
      {!isLoading && !isError && packs.map((pack) => (
        <AttemptsPacks key={pack.id} pack={pack} onBuy={onBuy} isBuying={buyingPackId != null} />
      ))}
    </div>
  </div>
);

export default AssessmentPackCard;
